import { Body } from "@components/Typography";
import { i18n, Translations } from "@i18n";
import { useStyles } from "./styles";
import { SeeMoreButtonProps } from "./types";

export const SeeMoreButton = ({ onClick }: SeeMoreButtonProps) => {
  const styles = useStyles();

  return (
    <div onClick={onClick} style={styles.container}>
      <Body style={styles.text}>{i18n.t(Translations.InvestmentBreakdownSeeMoreCTA)}</Body>
    </div>
  );
};
